<template>
  <div>
    <div :class="$style.box" @touchmove.prevent>
      <div :class="$style.intro">
        <div :class="$style.title">活动介绍</div>
        <div :class="$style.info">
          <p :class="$style.tips">活动详情</p>
          <img :class="$style.gift" :src="gift" alt />
          <p>看直播，玩游戏赢现金好礼，简单轻松</p>
          <p :class="$style.tips">活动规则</p>
          <img :class="$style.tip" :src="tip" alt />
          <p>*开服首日内游戏角色转生达到4转 10元现金；</p>
          <p>*开服7天内游戏角色转生达到14转 100元现金；</p>
          <p>*开服15天内游戏角色转生达到21转 1000元现金；</p>
          <p>*开服30天内游戏角色转生达到25转 华为P30pro(256G)一台；</p>
          <p :class="$style.bold">(以上奖励到达即领，每档限领一次)</p>
          <p>1.本活动仅限2020.5.13-2020.5.31日进入活动指定区服选择界面最新区服的用户；</p>
          <p>2.本活动仅限通过活动链接注册创角用户；</p>
          <p>3.本活动仅限“超强手游推荐”微信公众号；</p>
          <p>4.开服时长和游戏角色转生以领取页面为准；</p>
          <p>5.每个用户限领一次，同一设备，同一手机号，同一身份证件，同一账号等任一条件，均视为同一用户；</p>
          <p>6.凡通过不正当手段刷领取奖励，活动主办方有权取消领奖资格；</p>
          <p>7.千元红包及华为P30pro（256G）达成条件者，需提供：游戏角色信息、红包领取页面截图、身份证件，7日内联系客服核实领取；</p>
          <p>8.如有问题可在红包领取界面填写问题；</p>
          <p>9.奖励发放在1-30个工作日内完成；</p>
          <p>10.本活动解释权在法律允许范围内归悦玩网络所有。</p>
          <!-- 关闭按钮 -->
          <img :class="$style.close" :src="close" @click="closeIntro" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from "@/config";

export default {
  data() {
    return {
      close: `${CDN_URL}/packet/close-big.png`,
      gift: `${CDN_URL}/packet/gift.png`,
      tip: `${CDN_URL}/packet/tip.png`
    };
  },
  methods: {
    closeIntro() {
      this.$emit("changeIntroShow");
    }
  }
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: $Introduction-mask;
  .intro {
    width: 298px;
    height: 367px;
    background: rgba(255, 255, 255, 1);
    border-radius: 11px;
    margin: 120px auto;
    .title {
      width: 100%;
      height: 49px;
      background: url("//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/packet/top-pic.png")
        no-repeat;
      background-size: cover;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 49px;
    }
    .info {
      width: 100%;
      height: 299px;
      // background-color: pink;
      padding: 18px;
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 12px;
      position: relative;
      .tips {
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }
      .bold {
        font-weight: bold;
        line-height: 20px;
      }
      > img {
        position: absolute;
      }
      .gift {
        width: 9px;
        left: 6px;
        top: 23px;
      }
      .tip {
        width: 9px;
        left: 6px;
        top: 55px;
      }
      .close {
        width: 26px;
        position: absolute;
        bottom: -60px;
        left: 50%;
        transform: translateX(-13px);
      }
    }
  }
}
</style>